"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBookingUpdateActivityTitle = void 0;
const postBookingTypeToStringMap = {
    preCarriage: 'Pre-Carriage',
    mainCarriage: 'Main-Carriage',
    onCarriage: 'On-Carriage',
    cargo: 'Cargo details',
    containers: 'Amount/type of containers',
    customs: 'Customs',
    services: 'Services',
    chargeable_weight: 'Chargeable Weight',
};
const getBookingUpdateActivityTitle = (activity) => {
    const postBookingType = activity.postBookingType ? postBookingTypeToStringMap[activity.postBookingType] : '';
    const postBookingSubType = activity.postBookingSubType ? activity.postBookingSubType : '';
    const manualPricing = activity.isManual ? '(Manual Pricing)' : '';
    return activity.postBookingType
        ? `Post Booking Change: ${postBookingType} ${postBookingSubType} ${manualPricing}`
        : `Post Booking Change ${manualPricing}`;
};
exports.getBookingUpdateActivityTitle = getBookingUpdateActivityTitle;
//# sourceMappingURL=getBookingUpdateActivityTitle.js.map